import { Link } from 'react-router-dom'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import TableLoader from '@components/TableLoader/TableLoader'
import camelCaseToTitle from '@utils/camel-case-to-title'

function DetailsTable({ transaction, fields, loading }) {
  return (
    <Card>
      <Card.Header>Transaction Details</Card.Header>
      <Table responsive bordered hover striped className='card-table'>
        {loading ? (
          <TableLoader />
        ) : (
          <tbody>
            { fields.map((field) => (
              <tr key={field}>
                <th className='col-lg-3'>{camelCaseToTitle(field)}</th>
                <td>{transaction[field]}</td>
              </tr>
            ))}
            <tr>
              <th className='col-lg-3'>Transaction Batch</th>
              <td>
                <Link to={`/transaction-batches/${transaction.transactionBatch.id}`}>
                  {transaction.transactionBatch.number || transaction.transactionBatch.id}
                </Link>
              </td>
            </tr>
          </tbody>
        )}
      </Table>
    </Card>
  )
}

export default DetailsTable
